

const firebaseConfig = {
    apiKey: "AIzaSyAGiqcoLvrQm1FZIoyGRKXhC6OXbS388Pg",
    authDomain: "health-care-4c5ef.firebaseapp.com",
    projectId: "health-care-4c5ef",
    storageBucket: "health-care-4c5ef.appspot.com",
    messagingSenderId: "467913614858",
    appId: "1:467913614858:web:df615bfd71ce76e8d0e1f3"
  };

  export default firebaseConfig;